import React from 'react';
import { SPECIALISTS_DATA } from '../constants';
import { Linkedin, Link } from 'lucide-react';

const Specialists: React.FC = () => {
  return (
    <section id="specialists" className="py-20 bg-white dark:bg-gray-950">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white">Nuestro Equipo de Especialistas</h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 mt-4 max-w-2xl mx-auto">
            Profesionales altamente cualificados y comprometidos con tu bienestar.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {SPECIALISTS_DATA.map((specialist, index) => (
            <div key={index} className="bg-gray-50 dark:bg-gray-800 rounded-lg shadow-md overflow-hidden text-center group">
              <img 
                src={specialist.photo} 
                alt={`Foto de ${specialist.name}`}
                aria-label={`Foto de ${specialist.name}`}
                name={`Foto de ${specialist.name}`}
                id={`Foto de ${specialist.name}`}
                width="500"
                height="500" 
                className="w-full h-64 object-cover object-center group-hover:scale-105 transition-transform duration-300" />
              <div className="p-6">
                <h3 className="text-xl font-bold text-secondary dark:text-white">{specialist.name}</h3>
                <p className="font-semibold text-primary mb-2">{specialist.specialty}</p>
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">{specialist.experience} años de experiencia</p>
                <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">{specialist.bio}</p>
                <div className="flex justify-center items-center gap-3 mb-4">
                  {specialist.socialLinks.linkedin && (
                    <a href={specialist.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#0e76a8] dark:hover:text-[#0e76a8] transition-colors" aria-label={`LinkedIn de ${specialist.name}`}>
                      <Linkedin />
                    </a>
                  )}
                   {specialist.socialLinks.others && (
                    <a href={specialist.socialLinks.others} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary dark:hover:text-primary transition-colors" aria-label={`Otro enlace de ${specialist.name}`}>
                      <Link />
                    </a>
                  )}
                </div>
                <a
                  href="/booking"
                  className="inline-block bg-primary text-white px-5 py-2 rounded-xl font-semibold text-sm hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105"
                >
                  Agendar Cita
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Specialists;